import { render, staticRenderFns } from "./GetCoordinate.vue?vue&type=template&id=5ceb7d37&"
import script from "./GetCoordinate.vue?vue&type=script&lang=js&"
export * from "./GetCoordinate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports